<template>
    <div :class="'rsk-form'+(isExpand?'--expand':'')">
            <select :class="clazz" :value="modelValue" @change="change">
                <option></option>
                <option :value="item.value" v-for="(item, index) in options" >{{item.label}}</option>
            </select>
        </div>
</template>
<script>
import { ref } from 'vue';
export default {
    props: {
        modelValue: {
            type: [String, Number],
            default: ""
        },
        isMin:{
            type: Boolean,
            default: false
        },
        isExpand:{
            type: Boolean,
            default: false
        },
        /**
         * {label, value}
         */
        options: {
            type: Array,
            default: []
        }
    },
    setup(props, { emit }) {
        function change( e ) {
          const latestValue = e?.target?.value ?? "";
            emit("update:modelValue",latestValue);
            emit("onChange", latestValue);
        }
        const clazz = ref('rsk-input rsk-input')
        if(props.isMin || props.isExpand) {
            if(props.isExpand) {
                clazz.value = 'rsk-input rsk-input--expand'
            }else {
                clazz.value = ''
            }
        }
        return {
            ...props,
            clazz,
            change,
        }
    },
}
</script>
